import { render } from "./ChatFooter.vue?vue&type=template&id=02c86444&scoped=true"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"

import "./ChatFooter.vue?vue&type=style&index=0&id=02c86444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c86444"]])

export default __exports__